import React from 'react';
import { CONTRACT } from '../data';
import '../styles/ticker.css';

const ITEMS = [
  'community meme token on wax',
  `contract · ${CONTRACT}`,
  'available on external DEXs',
  'transfer mechanics on chain',
  'entertainment only',
  'max supply 420.69t',
  'no investment product',
];

const Ticker = () => {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <div className="ticker" role="marquee" aria-label="$KEK highlights">
      <div className="ticker-track">
        {loop.map((t, i) => (
          <span className="ticker-item" key={i}>
            <span className="ticker-frog" aria-hidden="true">🐸</span>
            {t}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Ticker;
